<template>
<div id="app" class="site container hfeed" style="height: auto !important">
  <HeadNav :selectedLanguage="selectedLanguage" page="download" />

  <div id="content" class="site-content dl-site-content">
    <article id="article" class="center dl-article">

      <BreadcrumbNav variant="hero" label="Download" style="margin-bottom: 16px;" />

      <!-- ========== Hero 下载区 ========== -->
      <section class="dl-hero" aria-labelledby="dl-hero-title">
        <div class="dl-hero-badge">
          <span class="dl-badge-dot"></span>
          Latest Version 2026 · Anti-Ban Built-in · 55 MB
        </div>
        <h1 id="dl-hero-title" class="dl-hero-title">Download GB WhatsApp APK</h1>
        <p class="dl-hero-subtitle">
          Get the most feature-rich WhatsApp mod — privacy controls, auto-reply, custom themes,
          anti-delete messages, and built-in anti-ban protection. Free download for Android.
        </p>
        <div class="dl-hero-download-area">
          <button class="dl-download-btn" @click="downloadfrom('hero')" >
            <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true">
              <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
            </svg>
            Download APK Free
          </button>
          <p class="dl-hero-note">Free · 55MB · Android 4.4+ · No root required · No ads</p>
        </div>
        <div class="dl-version-strip" role="complementary" aria-label="Version information">
          <div class="dl-version-item">
            <span class="dl-version-label">Version</span>
            <span class="dl-version-val">v17.80</span>
          </div>
          <div class="dl-version-sep" aria-hidden="true"></div>
          <div class="dl-version-item">
            <span class="dl-version-label">Updated</span>
            <span class="dl-version-val">April 2026</span>
          </div>
          <div class="dl-version-sep" aria-hidden="true"></div>
          <div class="dl-version-item">
            <span class="dl-version-label">Package</span>
            <span class="dl-version-val">com.gbwhatsapp</span>
          </div>
          <div class="dl-version-sep" aria-hidden="true"></div>
          <div class="dl-version-item">
            <span class="dl-version-label">Android</span>
            <span class="dl-version-val">4.4+</span>
          </div>
        </div>
      </section>

      <!-- ========== App Information ========== -->
      <section class="dl-section dl-app-info-section" aria-labelledby="dl-info-title">
        <h2 id="dl-info-title" class="dl-section-title">App Information</h2>
        <div class="dl-info-table">
          <div class="dl-info-row">
            <span class="dl-info-label">App Name</span>
            <span class="dl-info-val">GB WhatsApp Pro</span>
          </div>
          <div class="dl-info-row">
            <span class="dl-info-label">Version</span>
            <span class="dl-info-val">v17.80 (April 2026)</span>
          </div>
          <div class="dl-info-row">
            <span class="dl-info-label">File Size</span>
            <span class="dl-info-val">55 MB</span>
          </div>
          <div class="dl-info-row">
            <span class="dl-info-label">Package Name</span>
            <span class="dl-info-val dl-info-mono">com.gbwhatsapp</span>
          </div>
          <div class="dl-info-row">
            <span class="dl-info-label">Android Required</span>
            <span class="dl-info-val">Android 4.4 (KitKat) or above</span>
          </div>
          <div class="dl-info-row">
            <span class="dl-info-label">Category</span>
            <span class="dl-info-val">Communication · WhatsApp Mod</span>
          </div>
          <div class="dl-info-row">
            <span class="dl-info-label">Developer</span>
            <span class="dl-info-val">GB WhatsApp Team</span>
          </div>
          <div class="dl-info-row">
            <span class="dl-info-label">License</span>
            <span class="dl-info-val">Free · No subscription</span>
          </div>
          <div class="dl-info-row dl-info-row--highlight">
            <span class="dl-info-label">Ban Risk</span>
            <span class="dl-info-val dl-info-warn">Low-Medium · Use anti-ban features</span>
          </div>
          <div class="dl-info-row">
            <span class="dl-info-label">Official Site</span>
            <span class="dl-info-val"><a href="/" class="dl-link">gbwhatsapp.com</a></span>
          </div>
        </div>
      </section>

      <!-- ========== WhatsApp Mods Navigation ========== -->
      <section class="dl-section dl-mods-section" aria-labelledby="dl-mods-title">
        <h2 id="dl-mods-title" class="dl-section-title">Explore Other WhatsApp Mods</h2>
        <p class="dl-section-desc">Compare the most popular WhatsApp modifications side by side.</p>
        <div class="dl-mods-grid">
          <a href="/fmwhatsapp/" class="dl-mod-item">
            <div class="dl-mod-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>
            </div>
            <span class="dl-mod-name">FMWhatsApp</span>
            <span class="dl-mod-desc">Extended privacy &amp; themes</span>
          </a>
          <a href="/yowhatsapp/" class="dl-mod-item">
            <div class="dl-mod-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M9.5 4C5.91 4 3 6.91 3 10.5c0 2.37 1.26 4.45 3.15 5.68L5 21l5.42-2.15C11.55 19.54 13.47 20 15.5 20 19.09 20 22 17.09 22 13.5S19.09 7 15.5 7c-.5 0-1 .04-1.48.12L10.5 4z"/></svg>
            </div>
            <span class="dl-mod-name">YoWhatsApp</span>
            <span class="dl-mod-desc">Lock chat &amp; built-in themes</span>
          </a>
          <a href="/whatsapp-plus/" class="dl-mod-item">
            <div class="dl-mod-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>
            </div>
            <span class="dl-mod-name">WhatsApp Plus</span>
            <span class="dl-mod-desc">Oldest mod, high customization</span>
          </a>
          <a href="/ogwhatsapp/" class="dl-mod-item">
            <div class="dl-mod-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M17.65 6.35A7.958 7.958 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>
            </div>
            <span class="dl-mod-name">OGWhatsApp</span>
            <span class="dl-mod-desc">Lightweight, core features only</span>
          </a>
        </div>
      </section>

      <!-- ========== Features List ========== -->
      <section class="dl-section dl-features-section" aria-labelledby="dl-features-title">
        <h2 id="dl-features-title" class="dl-section-title">GB WhatsApp Features</h2>
        <ul class="dl-features-list" aria-label="Feature list">
          <li class="dl-feature-item">
            <span class="dl-feature-check" aria-hidden="true">&#10003;</span>
            <span><strong>Hide Blue Ticks</strong> — Read messages without sending read receipts</span>
          </li>
          <li class="dl-feature-item">
            <span class="dl-feature-check" aria-hidden="true">&#10003;</span>
            <span><strong>Freeze Last Seen</strong> — Appear offline at all times</span>
          </li>
          <li class="dl-feature-item">
            <span class="dl-feature-check" aria-hidden="true">&#10003;</span>
            <span><strong>Auto Reply</strong> — Set automatic responses for business or personal use</span>
          </li>
          <li class="dl-feature-item">
            <span class="dl-feature-check" aria-hidden="true">&#10003;</span>
            <span><strong>Custom Themes</strong> — Apply 5,000+ themes or build your own</span>
          </li>
          <li class="dl-feature-item">
            <span class="dl-feature-check" aria-hidden="true">&#10003;</span>
            <span><strong>Anti-Delete Messages</strong> — See messages others deleted</span>
          </li>
          <li class="dl-feature-item">
            <span class="dl-feature-check" aria-hidden="true">&#10003;</span>
            <span><strong>Anti-Delete Status</strong> — View deleted Status updates</span>
          </li>
          <li class="dl-feature-item">
            <span class="dl-feature-check" aria-hidden="true">&#10003;</span>
            <span><strong>Download Status</strong> — Save any WhatsApp Status photo or video</span>
          </li>
          <li class="dl-feature-item">
            <span class="dl-feature-check" aria-hidden="true">&#10003;</span>
            <span><strong>DND Mode</strong> — Pause notifications independently from system settings</span>
          </li>
          <li class="dl-feature-item">
            <span class="dl-feature-check" aria-hidden="true">&#10003;</span>
            <span><strong>Ghost Mode</strong> — Complete invisibility while reading</span>
          </li>
          <li class="dl-feature-item">
            <span class="dl-feature-check" aria-hidden="true">&#10003;</span>
            <span><strong>Message Scheduler</strong> — Schedule messages to send at a specific time</span>
          </li>
          <li class="dl-feature-item">
            <span class="dl-feature-check" aria-hidden="true">&#10003;</span>
            <span><strong>Anti-Ban Protection</strong> — Built-in measures to reduce ban risk</span>
          </li>
          <li class="dl-feature-item">
            <span class="dl-feature-check" aria-hidden="true">&#10003;</span>
            <span><strong>Extended Media Sharing</strong> — Share files up to 700MB (vs official 100MB limit)</span>
          </li>
        </ul>
      </section>

      <!-- ========== Installation Instructions ========== -->
      <section class="dl-section dl-install-section" aria-labelledby="dl-install-title">
        <h2 id="dl-install-title" class="dl-section-title">How to Install GB WhatsApp on Android</h2>
        <ol class="dl-install-steps" aria-label="Installation steps">
          <li class="dl-install-step">
            <div class="dl-step-num" aria-hidden="true">1</div>
            <div class="dl-step-content">
              <strong>Enable Unknown Sources</strong> — Go to Settings &rarr; Security (or Apps) &rarr; enable
              "Unknown sources" or "Install unknown apps" for your browser. This allows APK installation outside the Play Store.
            </div>
          </li>
          <li class="dl-install-step">
            <div class="dl-step-num" aria-hidden="true">2</div>
            <div class="dl-step-content">
              <strong>Download the APK</strong> — Tap the download button above to get the latest
              <strong>GB WhatsApp</strong> APK. Make sure you have at least 150 MB of free storage.
            </div>
          </li>
          <li class="dl-install-step">
            <div class="dl-step-num" aria-hidden="true">3</div>
            <div class="dl-step-content">
              <strong>Backup Your Chats</strong> — Open your current WhatsApp &rarr; Settings &rarr; Chats &rarr;
              Chat Backup &rarr; tap "Back Up". Use Wi-Fi and wait for the backup to complete.
            </div>
          </li>
          <li class="dl-install-step">
            <div class="dl-step-num" aria-hidden="true">4</div>
            <div class="dl-step-content">
              <strong>Uninstall Official WhatsApp</strong> — Uninstall the official WhatsApp from your
              device before installing GB WhatsApp. Your chat history is safe in the backup you just created.
            </div>
          </li>
          <li class="dl-install-step">
            <div class="dl-step-num" aria-hidden="true">5</div>
            <div class="dl-step-content">
              <strong>Install the APK</strong> — Open the downloaded APK file. If prompted, confirm
              installation. The app will install within seconds.
            </div>
          </li>
          <li class="dl-install-step">
            <div class="dl-step-num" aria-hidden="true">6</div>
            <div class="dl-step-content">
              <strong>Verify Your Number</strong> — Enter your phone number in international format
              (e.g., +1 234 567 8900) and complete SMS or voice verification.
            </div>
          </li>
          <li class="dl-install-step">
            <div class="dl-step-num" aria-hidden="true">7</div>
            <div class="dl-step-content">
              <strong>Restore Your Chats</strong> — When prompted, tap "Restore" to recover your
              messages from the local backup. <em>Note: GB WhatsApp backups are stored locally, not on Google Drive.</em>
            </div>
          </li>
          <li class="dl-install-step">
            <div class="dl-step-num" aria-hidden="true">8</div>
            <div class="dl-step-content">
              <strong>You're Done!</strong> — Set up your profile, explore privacy settings, and
              enjoy <strong>GB WhatsApp</strong>. Create a new backup immediately after setup.
            </div>
          </li>
        </ol>
        <p class="dl-install-note">
          For troubleshooting common installation errors, visit our
          <a href="/how-to-install-gb-whatsapp/" class="dl-link">full installation guide</a>.
        </p>
      </section>

      <!-- ========== System Requirements ========== -->
      <section class="dl-section dl-req-section" aria-labelledby="dl-req-title">
        <h2 id="dl-req-title" class="dl-section-title">System Requirements</h2>
        <div class="dl-req-grid" role="list">
          <div class="dl-req-card" role="listitem">
            <div class="dl-req-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/></svg>
            </div>
            <h3 class="dl-req-card-title">Operating System</h3>
            <p class="dl-req-desc">Android 4.4 (KitKat) or higher. GB WhatsApp does not support iOS, Windows Phone, or Symbian.</p>
          </div>
          <div class="dl-req-card" role="listitem">
            <div class="dl-req-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z"/></svg>
            </div>
            <h3 class="dl-req-card-title">Storage Space</h3>
            <p class="dl-req-desc">Minimum 150 MB of free internal storage. WhatsApp media (photos, videos, voice messages) requires additional space.</p>
          </div>
          <div class="dl-req-card" role="listitem">
            <div class="dl-req-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3a4.237 4.237 0 0 0-6 0zm-4-4l2 2a7.074 7.074 0 0 1 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"/></svg>
            </div>
            <h3 class="dl-req-card-title">Internet Connection</h3>
            <p class="dl-req-desc">Stable mobile data or Wi-Fi connection required for installation, verification, and app operation.</p>
          </div>
          <div class="dl-req-card" role="listitem">
            <div class="dl-req-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
            </div>
            <h3 class="dl-req-card-title">Phone Number</h3>
            <p class="dl-req-desc">A valid phone number (any carrier) for WhatsApp verification. Can be the same number you previously used with official WhatsApp.</p>
          </div>
        </div>
      </section>

      <!-- ========== FAQ ========== -->
      <section class="dl-section dl-faq-section" aria-labelledby="dl-faq-title">
        <h2 id="dl-faq-title" class="dl-section-title">Frequently Asked Questions</h2>
        <div class="dl-faq-list" role="list">
          <div
            v-for="(item, index) in dlFaqItems"
            :key="index"
            class="dl-faq-item"
            :class="{ open: item.open }"
            role="listitem"
            @click="toggleDlFaq(item)"
          >
            <div class="dl-faq-q">
              <span>{{ item.q }}</span>
              <svg class="dl-faq-arrow" viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
                <path d="M7 10l5 5 5-5z"/>
              </svg>
            </div>
            <div class="dl-faq-a" v-show="item.open">
              <div v-html="item.a"></div>
            </div>
          </div>
        </div>
      </section>

      <!-- ========== Disclaimer ========== -->
      <section class="dl-section dl-disclaimer-section" aria-labelledby="dl-disclaimer-title">
        <h2 id="dl-disclaimer-title" class="dl-section-title dl-section-title--warn">Disclaimer</h2>
        <div class="dl-disclaimer-body">
          <p>
            <strong>GB WhatsApp</strong> is a third-party modified version of the official WhatsApp Messenger.
            It is <strong>not developed, endorsed, or supported by WhatsApp Inc.</strong>, Meta Platforms, or any
            associated companies. This website provides informational content and APK download links for
            educational purposes only.
          </p>
          <p>
            Using modified WhatsApp applications may violate WhatsApp's Terms of Service and could result in
            temporary or permanent account restrictions. Users install and use GB WhatsApp at their own risk.
            We strongly recommend maintaining a backup phone number or secondary device for WhatsApp communication.
          </p>
          <p>
            This website does not collect, store, or share any personal data beyond standard analytics.
            Read our <a href="/privacy-policy/" class="dl-link">Privacy Policy</a> and
            <a href="/terms-of-service/" class="dl-link">Terms of Service</a> for more information.
          </p>
        </div>
      </section>

      <!-- ========== 底部下载卡片 ========== -->
      <section class="dl-bottom-cta" aria-labelledby="dl-bottom-cta-title">
        <div class="dl-bottom-cta-inner">
          <div class="dl-bottom-cta-icon" aria-hidden="true">
            <img src="@/assets/logo.webp" alt="GB WhatsApp" width="72" height="72" onerror="this.style.display='none'">
          </div>
          <div class="dl-bottom-cta-info">
            <h2 id="dl-bottom-cta-title">Ready to Get Started?</h2>
            <p>Download the latest stable <strong>GB WhatsApp</strong> APK — free, safe, and packed with features.</p>
            <div class="dl-bottom-meta">
              <span>Free · 55MB · Android 4.4+</span>
            </div>
          </div>
          <div class="dl-bottom-cta-action">
            <button class="dl-download-btn dl-download-btn--large" @click="downloadfrom('bottom')" :disabled="!apk">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
                <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
              </svg>
              Download Free APK
            </button>
            <p class="dl-bottom-note">Tap to download &middot; APK file &middot; No registration</p>
          </div>
        </div>
      </section>

    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';
import BreadcrumbNav from '@/components/BreadcrumbNav.vue';

export default {
  name: 'Download',
  data() {
    return {
      pageName: 'download',
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
      dlFaqItems: [
        {
          q: 'Is GB WhatsApp free to download?',
          a: `<p>Yes, <strong>GB WhatsApp</strong> is completely free to download and use. There are no subscription fees, no in-app purchases, and no premium features locked behind a paywall. You get the full feature set — including all privacy controls, themes, and automation features — at no cost.</p>`,
          open: false,
        },
        {
          q: 'Is GB WhatsApp safe for my account?',
          a: `<p><strong>GB WhatsApp</strong> carries more ban risk than the official WhatsApp. WhatsApp's policy prohibits the use of unofficial clients and may temporarily or permanently restrict accounts detected using them. That said, millions of users worldwide use GB WhatsApp without issues. Using the <a href="/" class="dl-link">latest stable build</a> and following <a href="/how-to-avoid-ban/" class="dl-link">ban-avoidance guidelines</a> significantly reduces the risk.</p>`,
          open: false,
        },
        {
          q: 'Will I lose my chat history after installing GB WhatsApp?',
          a: `<p>If you follow the installation steps correctly, your chats will be preserved. The key is to: (1) create a <strong>GB WhatsApp local backup</strong> before updating, (2) never use a Google Drive backup from official WhatsApp to restore into GB WhatsApp — they are incompatible. Follow our <a href="/how-to-backup-and-restore-gb-whatsapp/" class="dl-link">backup guide</a> for a safe migration workflow.</p>`,
          open: false,
        },
        {
          q: 'Can I use GB WhatsApp alongside official WhatsApp?',
          a: `<p>Not on the same phone number simultaneously. You can install both apps on the same device using different package names, but they cannot both be logged into the same phone number at the same time. The practical approach is to use <strong>GB WhatsApp</strong> as your primary client and official WhatsApp Business on a secondary device.</p>`,
          open: false,
        },
        {
          q: 'How often should I update GB WhatsApp?',
          a: `<p>Check for updates whenever WhatsApp releases a major version (which they do roughly every 2–4 weeks). Using an outdated <strong>GB WhatsApp</strong> build when WhatsApp updates its server protocol can increase ban risk. Always create a backup before updating.</p>`,
          open: false,
        },
        {
          q: 'Does GB WhatsApp work on Android tablets?',
          a: `<p><strong>GB WhatsApp</strong> is designed primarily for Android smartphones. It can be installed on Android tablets with phone functionality (not Wi-Fi-only tablets) if they have a SIM card slot and a valid phone number for verification. Some users report success on tablets without SIM cards using virtual phone number apps, though this is less reliable.</p>`,
          open: false,
        },
        {
          q: 'What is the difference between GB WhatsApp and GB WhatsApp Pro?',
          a: `<p>The terms are often used interchangeably. "GB WhatsApp Pro" typically refers to the latest stable build with all premium features unlocked by default, rather than a separate paid version. There is no paid "Pro" tier — all features are included in the free download.</p>`,
          open: false,
        },
      ],
    };
  },
  components: {
    HeadNav,
    BreadcrumbNav,
  },
  computed: {
    locale() {
      const name = this.$route?.name || '';
      const lang = name.split('-')[0];
      return ['en', 'es', 'hi', 'pt', 'id'].includes(lang) ? lang : 'en';
    },
    selectedLanguage() {
      return this.locale;
    },
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    download() {
      console.log(this.apk);
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    },
    toggleDlFaq(item) {
      item.open = !item.open;
    },
  },
};
</script>

<style lang="scss" scoped>
// 主题变量（深海蓝琥珀系）
$brand:        var(--theme-primary, #1E3A5F);
$brand-dark:   var(--theme-primary-dark, #0F2347);
$brand-soft:   var(--theme-primary-light, #3B82C4);
$brand-pale:   var(--theme-primary-pale, #EBF2FC);
$text-main:    var(--theme-text-main, #0F2347);
$text-body:    var(--theme-text-body, #2d3748);
$text-muted:   var(--theme-text-muted, #64748b);
$text-faint:   var(--theme-text-faint, #94a3b8);
$text-inverse: var(--theme-text-inverse, #ffffff);
$border:       var(--theme-border, rgba(30,58,95,0.1));
$shadow-sm:    var(--theme-card-shadow, 0 2px 12px rgba(30,58,95,0.06));
$shadow-md:    var(--theme-card-shadow-md, 0 4px 20px rgba(30,58,95,0.08));
$shadow-lg:    var(--theme-card-shadow-lg, 0 12px 40px rgba(30,58,95,0.12));
$gradient:     var(--theme-gradient, linear-gradient(135deg, #0F2347 0%, #1E3A5F 100%));
$gradient-light: var(--theme-gradient-light, linear-gradient(135deg, #1E3A5F 0%, #3B82C4 100%));

@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&family=Outfit:wght@400;500;600;700;800&display=swap');

.dl-site-content {
  // background: var(--theme-page-bg, #f4f7fb);
  min-height: 100vh;
}

.dl-article {
  max-width: 1080px;
  margin: 0 auto;
}

/* ========== Hero ========== */
.dl-hero {
  background: $gradient;
  border-radius: 24px;
  padding: 56px 48px 48px;
  text-align: center;
  margin-bottom: 40px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 16px 56px rgba(15,35,71,0.25);

  &::before {
    content: '';
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    width: 200px;
    height: 4px;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent);
    border-radius: 2px;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse at 50% 0%, rgba(59,130,196,0.3) 0%, transparent 70%);
    pointer-events: none;
  }
}

.dl-hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.8);
  margin-bottom: 20px;
  background: rgba(255,255,255,0.12);
  padding: 6px 16px;
  border-radius: 50px;
  border: 1px solid rgba(255,255,255,0.2);
}

.dl-badge-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #F59E0B;
  animation: dlPulse 2s ease-in-out infinite;
}

@keyframes dlPulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.6; transform: scale(0.85); }
}

.dl-hero-title {
  font-family: 'Outfit', sans-serif;
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 800;
  color: $text-inverse;
  margin-bottom: 20px;
  letter-spacing: -0.02em;
  position: relative;
  z-index: 1;
}

.dl-hero-subtitle {
  font-family: 'DM Sans', sans-serif;
  font-size: 16px;
  line-height: 1.7;
  color: rgba(255,255,255,0.75);
  max-width: 560px;
  margin: 0 auto 36px;
  position: relative;
  z-index: 1;
}

.dl-hero-download-area {
  position: relative;
  z-index: 1;
  margin-bottom: 32px;
}

.dl-download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: #F59E0B;
  color: #ffffff;
  border: none;
  padding: 18px 48px;
  border-radius: 16px;
  font-family: 'Outfit', sans-serif;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  box-shadow: 0 8px 28px rgba(245,158,11,0.4);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent);
    transition: left 0.6s ease;
  }

  &:hover {
    background: #D97706;
    transform: translateY(-3px);
    box-shadow: 0 14px 40px rgba(245,158,11,0.45);
    &::before { left: 100%; }
  }

  &:active { transform: translateY(-1px); }
  &:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
  svg { flex-shrink: 0; }
}

.dl-download-btn--large {
  padding: 20px 52px;
  font-size: 20px;
  border-radius: 18px;
}

.dl-hero-note {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  color: rgba(255,255,255,0.6);
  margin-top: 14px;
}

.dl-version-strip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 14px;
  padding: 16px 28px;
  max-width: 600px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  flex-wrap: wrap;
  gap: 12px;
}

.dl-version-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  flex: 1;
  min-width: 80px;
}

.dl-version-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.5);
}

.dl-version-val {
  font-family: 'Outfit', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: rgba(255,255,255,0.9);
}

.dl-version-sep {
  width: 1px;
  height: 32px;
  background: rgba(255,255,255,0.15);
  flex-shrink: 0;
}

/* ========== Sections ========== */
.dl-section {
  background: var(--theme-card-bg, #ffffff);
  border-radius: 20px;
  padding: 40px 44px;
  margin-bottom: 32px;
  border: 1px solid $border;
  box-shadow: $shadow-sm;
}

.dl-section-title {
  font-family: 'Outfit', sans-serif;
  font-size: 1.6em;
  font-weight: 700;
  color: $brand-dark;
  margin-bottom: 28px;
  text-align: center;
  letter-spacing: -0.02em;
  position: relative;
  padding-bottom: 16px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 56px;
    height: 3px;
    background: $gradient;
    border-radius: 2px;
  }

  &--warn {
    color: #92400e;
    &::after { background: linear-gradient(90deg, #F59E0B, #D97706); }
  }
}

.dl-section-desc {
  font-family: 'DM Sans', sans-serif;
  font-size: 15px;
  color: $text-muted;
  text-align: center;
  margin-bottom: 28px;
  line-height: 1.6;
}

/* ========== App Info Table ========== */
.dl-info-table {
  border-radius: 14px;
  border: 1px solid $border;
  overflow: hidden;
}

.dl-info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid $border;

  &:last-child { border-bottom: none; }

  &--highlight {
    background: #FEF3C7;
    .dl-info-label { color: #92400e; }
    .dl-info-val { color: #92400e; }
  }
}

.dl-info-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 13.5px;
  font-weight: 600;
  color: $text-muted;
  flex-shrink: 0;
  min-width: 140px;
}

.dl-info-val {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: $text-main;
  text-align: right;
}

.dl-info-mono {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: $brand-dark;
}

.dl-info-warn { font-weight: 700; color: #b45309; }

.dl-link {
  color: $brand;
  text-decoration: underline;
  text-underline-offset: 2px;
  font-weight: 500;
  &:hover { color: $brand-dark; }
}

/* ========== Mods Grid ========== */
.dl-mods-section {
  background: $brand-pale;
  border-color: rgba(30,58,95,0.12);
}

.dl-mods-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.dl-mod-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 24px 16px;
  background: #ffffff;
  border: 2px solid $border;
  border-radius: 16px;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: $gradient;
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }

  &:hover {
    border-color: $brand;
    transform: translateY(-4px);
    box-shadow: 0 10px 30px rgba(30,58,95,0.12);
    background: $gradient;
    &::before { transform: scaleX(1); }
    .dl-mod-icon { background: rgba(255,255,255,0.2); color: #fff; }
    .dl-mod-name { color: #fff; }
    .dl-mod-desc { color: rgba(255,255,255,0.75); }
  }
}

.dl-mod-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: $brand-pale;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $brand;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.dl-mod-name {
  font-family: 'Outfit', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: $text-main;
  text-align: center;
  transition: color 0.3s ease;
}

.dl-mod-desc {
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  color: $text-muted;
  text-align: center;
  line-height: 1.5;
  transition: color 0.3s ease;
}

/* ========== Features List ========== */
.dl-features-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.dl-feature-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 16px;
  border-radius: 10px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  color: $text-body;
  line-height: 1.55;
  background: var(--theme-section-alt-bg, #f8fafd);
  border: 1px solid $border;
  transition: border-color 0.18s ease;

  &:hover { border-color: rgba(30,58,95,0.2); }
}

.dl-feature-check {
  flex-shrink: 0;
  color: #16a34a;
  font-size: 15px;
  font-weight: 700;
  margin-top: 1px;
}

/* ========== Install Steps ========== */
.dl-install-steps {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 23px;
    top: 36px;
    bottom: 36px;
    width: 2px;
    background: linear-gradient(to bottom, $brand, $brand-soft);
    border-radius: 2px;
  }
}

.dl-install-step {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  padding: 20px 0;
  position: relative;
}

.dl-step-num {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: $gradient;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Outfit', sans-serif;
  font-size: 16px;
  font-weight: 700;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  box-shadow: 0 4px 12px rgba(30,58,95,0.25);
}

.dl-step-content {
  flex: 1;
  padding-top: 10px;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  line-height: 1.7;
  color: $text-body;

  strong { color: $brand-dark; font-weight: 700; }
  em { color: $text-muted; font-style: italic; }
}

.dl-install-note {
  margin-top: 24px;
  font-family: 'DM Sans', sans-serif;
  font-size: 13.5px;
  color: $text-muted;
  text-align: center;
  padding: 14px;
  background: $brand-pale;
  border-radius: 10px;
  border: 1px solid rgba(30,58,95,0.1);
}

/* ========== Requirements Grid ========== */
.dl-req-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.dl-req-card {
  background: $brand-pale;
  border: 1px solid rgba(30,58,95,0.1);
  border-radius: 16px;
  padding: 28px 24px;
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    box-shadow: $shadow-md;
    transform: translateY(-2px);
  }
}

.dl-req-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: $gradient;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-bottom: 16px;
}

.dl-req-card-title {
  font-family: 'Outfit', sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: $text-main;
  margin-bottom: 8px;
}

.dl-req-desc {
  font-family: 'DM Sans', sans-serif;
  font-size: 13.5px;
  color: $text-muted;
  line-height: 1.7;
  margin: 0;
}

/* ========== FAQ ========== */
.dl-faq-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dl-faq-item {
  border: 1px solid $border;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover { box-shadow: $shadow-sm; }
  &.open {
    box-shadow: $shadow-md;
    border-color: rgba(30,58,95,0.2);
    .dl-faq-q { color: $brand-dark; }
  }
}

.dl-faq-q {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  font-family: 'Outfit', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: $text-main;
  gap: 16px;
  transition: color 0.18s ease;

  .dl-faq-arrow {
    flex-shrink: 0;
    color: $text-faint;
    transition: transform 0.22s ease, color 0.18s ease;
  }
}

.dl-faq-item.open .dl-faq-q .dl-faq-arrow {
  transform: rotate(180deg);
  color: $brand;
}

.dl-faq-a {
  padding: 0 22px 18px;

  p {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    line-height: 1.8;
    color: $text-body;
    margin: 0;
  }

  .dl-link {
    color: $brand;
    text-decoration: underline;
    text-underline-offset: 2px;
    &:hover { color: $brand-dark; }
  }
}

/* ========== Disclaimer ========== */
.dl-disclaimer-section {
  background: #FEF3C7;
  border-color: rgba(146,64,14,0.2);
  border-left: 4px solid #F59E0B;

  .dl-section-title { color: #92400e; }
}

.dl-disclaimer-body {
  p {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    line-height: 1.8;
    color: #78350f;
    margin: 0 0 14px;

    &:last-child { margin-bottom: 0; }
    strong { font-weight: 700; }
  }

  .dl-link {
    color: #92400e;
    font-weight: 600;
    &:hover { color: #78350f; }
  }
}

/* ========== Bottom CTA ========== */
.dl-bottom-cta {
  background: $gradient;
  border-radius: 24px;
  padding: 48px 44px;
  box-shadow: 0 16px 48px rgba(15,35,71,0.2);
  margin-bottom: 40px;
}

.dl-bottom-cta-inner {
  display: flex;
  align-items: center;
  gap: 36px;
  flex-wrap: wrap;
  justify-content: space-between;
}

.dl-bottom-cta-icon {
  flex-shrink: 0;

  img {
    width: 72px;
    height: 72px;
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.2);
  }
}

.dl-bottom-cta-info {
  flex: 1;
  min-width: 200px;

  h2 {
    font-family: 'Outfit', sans-serif;
    font-size: 1.5em;
    font-weight: 700;
    color: #ffffff;
    margin: 0 0 8px;
  }

  p {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    color: rgba(255,255,255,0.75);
    line-height: 1.6;
    margin: 0;
  }
}

.dl-bottom-meta {
  margin-top: 8px;
  span {
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    color: rgba(255,255,255,0.6);
  }
}

.dl-bottom-cta-action {
  flex-shrink: 0;
  text-align: center;
}

.dl-bottom-note {
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  color: rgba(255,255,255,0.5);
  margin-top: 10px !important;
}

/* ========== Responsive ========== */
@media (max-width: 900px) {
  .dl-hero { padding: 40px 28px 36px; }
  .dl-section { padding: 32px 24px; }
  .dl-mods-grid { grid-template-columns: repeat(2, 1fr); }
  .dl-features-list { grid-template-columns: 1fr; }
  .dl-req-grid { grid-template-columns: 1fr; }
  .dl-install-steps::before { display: none; }
  .dl-bottom-cta-inner { flex-direction: column; text-align: center; }
  .dl-version-strip { flex-wrap: wrap; gap: 12px; padding: 14px 20px; }
  .dl-version-sep { display: none; }
}

@media (max-width: 600px) {
  .dl-hero { padding: 32px 20px 28px; border-radius: 18px; }
  .dl-hero-title { font-size: 1.8rem; }
  .dl-download-btn {
    padding: 16px 32px;
    font-size: 16px;
    width: 100%;
    max-width: 300px;
  }
  .dl-section { padding: 24px 18px; border-radius: 16px; }
  .dl-mods-grid { grid-template-columns: 1fr 1fr; gap: 12px; }
  .dl-mod-item { padding: 18px 12px; }
  .dl-step-num { width: 40px; height: 40px; font-size: 14px; }
  .dl-bottom-cta { padding: 32px 24px; border-radius: 18px; }
}
</style>
